/* eslint-disable */
import API from '@/api/api'

export default {
  GET_SIGNUP_SESSION () {
    return API.GET.signupSession()
  },
  GET_DIVISION ({}, data) {
    return API.GET.divisions.active(data)
  },
  SAVE_PROFILE ({ state }, data) {
    data.sessionId = state.signupSession
    return API.POST.profile(data)
  },
  UPDATE_DIVISIONS ({ state }, data) {
    let requestData = data
    data.sessionId = state.signupSession
    const currentUser = this.getters['users/currentUser']
    if (typeof currentUser !== 'undefined' && typeof currentUser.email !== 'undefined') {
      delete requestData['sessionId']
      requestData = {
        ...data,
        userId: currentUser._id
      }
    }
    return API.PUT.profileDivisions(requestData)
  },
  // Stripe
  GENERATE_STRIPE_INTENT ({ state }, data) {
    data.sessionId = state.signupSession
    return API.GET.stripe.paymentIntent(data)
  }
}
